export enum CountryAlpha2 {
    AFG = 'AF',
    ALB = 'AL',
    AND = 'AD',
    AGO = 'AO',
    ALG = 'DZ',
    ARG = 'AR',
    ARM = 'AM',
    AUS = 'AU',
    AUT = 'AT',
    AZE = 'AZ',
    BEL = 'BE',
    BUL = 'BG',
    BLR = 'BY',
    BRA = 'BR',
    CAN = 'CA',
    SUI = 'CH',
    CHN = 'CN',
    COL = 'CO',
    CRO = 'HR',
    CYP = 'CY',
    CZE = 'CZ',
    DEN = 'DK',
    EGY = 'EG',
    ESP = 'ES',
    EST = 'EE',
    FIN = 'FI',
    FRA = 'FR',
    GBR = 'GB',
    GEO = 'GE',
    GER = 'DE',
    GRE = 'GR',
    HUN = 'HU',
    IND = 'IN',
    IRL = 'IE',
    ISL = 'IS',
    ISR = 'IL',
    ITA = 'IT',
    JPN = 'JP',
    KAZ = 'KZ',
    KOR = 'KR',
    LAO = 'LA',
    LAT = 'LV',
    LIE = 'LI',
    LTU = 'LT',
    LUX = 'LU',
    LVA = 'LV',
    MEX = 'MX',
    MDA = 'MD',
    MKD = 'MK',
    MLT = 'MT',
    MNE = 'ME',
    MON = 'MC',
    NED = 'NL',
    NOR = 'NO',
    NZL = 'NZ',
    POL = 'PL',
    POR = 'PT',
    ROU = 'RO',
    RUS = 'RU',
    SRB = 'RS',
    SVK = 'SK',
    SLO = 'SI',
    SWE = 'SE',
    TGA = 'TO',
    TRI = 'TT',
    TTO = 'TT',
    TUR = 'TR',
    UKR = 'UA',
    USA = 'US',
    UZB = 'UZ',
    VEN = 'VE',
    RSA = 'ZA',
}
